import { render, staticRenderFns } from "./InvestmentOptionsListSection.vue?vue&type=template&id=9705790c&scoped=true"
import script from "./InvestmentOptionsListSection.vue?vue&type=script&lang=js"
export * from "./InvestmentOptionsListSection.vue?vue&type=script&lang=js"
import style0 from "./InvestmentOptionsListSection.vue?vue&type=style&index=0&id=9705790c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9705790c",
  null
  
)

export default component.exports